<h1>{{(user$ | async)?.displayName}}</h1>
<div *ngFor="let role of roles">

<input type="checkbox" kendoCheckBox [(ngModel)]="role.checked"/>
<kendo-label>{{role.name}}</kendo-label>
</div>
<ece-btn-icon
[text]="'user.grid.save.title' | i18n"
[icon]="'save'" (click)="save()"
></ece-btn-icon>
<ece-btn-icon
[text]="'user.grid.back.title' | i18n" (click)="goBack()"
></ece-btn-icon>
